export default __webpack_public_path__ + "static/media/Download.04298f23.svg";